//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useContext, } from 'react';

// === STYLE / MATERIAL UI ===
import { useTheme } from '@mui/material/styles';
import {
  Avatar,
} from '@mui/material';

import {
  Person,
} from '@mui/icons-material';

// === COMPONENTS ===
import { AppContext } from 'pages/App/components/AppContext/AppContext';

//#endregion

//-----------------------------------------------------------------
export function UserIcon(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]
  
  const { user_details } = useContext( AppContext );

  const theme = useTheme();

  const _styles = {
    main: {
      padding: '0.5rem',
    },
    avatar: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    }
  }

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return user_details ? (
      <Avatar aria-label='user-profile' sx={ _styles.avatar } onClick={props.onClick}>
        {user_details.initials ? user_details.initials : <Person /> }
      </Avatar>
    ) : null;
  }

  //#endregion

  return display();
}
